module.exports = __webpack_public_path__ + "img/mpg.11d55694.png";